var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({class:'anx-alert ' +
      "anx-alert-" + _vm.type + " " +
      (_vm.visibility ? 'visible ' : 'hidden ') +
      (_vm.fadeIn ? 'fade-in ' : '') +
      (_vm.fadeOut ? 'fade-out ' : '')},'div',_vm.attributes,false),[_c('div',{staticClass:"message"},[_c('span',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)]),_c('div',{staticClass:"dismiss",on:{"click":function($event){return _vm.input(!_vm.visibility)}}},[_vm._v("×")])])}
var staticRenderFns = []

export { render, staticRenderFns }